import { render, staticRenderFns } from "./approvals_list.vue.js?vue&type=template&id=431accde!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_list.vue?vue&type=template&id=431accde"
import script from "./approvals_list.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_list.vue?vue&type=script&lang=js"
export * from "./approvals_list.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports